import { BlankSlate } from '../components'

export const NotFound = () => (
  <BlankSlate
    title="This place is empty"
    description="What you're looking for isn't here"
  />
)
